<template>
  <div :class="['effect-get-item', { playing: isPlaying }]">
    <div ref="effect" class="effect">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap';

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isPlaying: false,
      targetOriginalWidth: 0,
      scaleRatio: 3,
      displayDuration: 0.6,
      movingDuration: 2,
    };
  },
  watch: {
    isPlaying(value) {
      this.handleAnimation(this.$slots.default[0].elm, value)
    },
    async "$store.state.animation.currentPlaying"(playing) {
      if (playing === `getItem-${this.name}`) {
        await this.$nextTick();
        this.play();
      }
    }
  },
  mounted() {
    if (!this.$slots.default) {
      return;
    }
  },
  methods: {
    play() {
      const target = this.$slots.default[0].elm;

      const [top, left] = this.getPosition(target);
      const [width, height] = this.getSize(target);

      this.targetOriginalWidth = width;
      target.style.width = `${width * this.scaleRatio}px`;

      const effect = this.$refs.effect;

      this.playTargetAnimation(target, effect, top, left, width, height);
    },
    playTargetAnimation(target, effect, top, left, width, height) {
      this.isPlaying = true;

      const {
        clientHeight: menuHeight,
        clientWidth: menuWidth,
      } = document.body;

      gsap.to(effect, {
        top: top - menuHeight / 2 + height / 2,
        left: left - menuWidth / 2 + width / 2,
        scale: 1 / this.scaleRatio,
        duration: this.movingDuration,
        delay: this.displayDuration,
        onComplete: () => {
          target.style.width = this.targetOriginalWidth + 'px';
          gsap.set(effect, { clearProps: 'all' });
          this.isPlaying = false;

          this.$store.dispatch("animation/next", `getItem-${this.name}`);
        },
      });
    },
    getPosition(target) {
      const rect = target.getBoundingClientRect();

      const top = Math.floor(rect.top * 100) / 100;
      const left = Math.floor(rect.left * 100) / 100;

      return [top, left];
    },
    getSize(target) {
      const style = getComputedStyle(target);

      const width = parseFloat(style.width);
      const height = parseFloat(style.height);

      return [width, height];
    },
    handleAnimation(target, isPlaying) {
      const tweens = gsap.getTweensOf(target)

      if (tweens.length !== 0) {
        if (isPlaying) {
          tweens.forEach(tween => {
            tween.progress(0).pause();
          });
        } else {
          tweens.forEach(tween => {
            tween.play();
          });
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.effect-get-item.playing {
  .effect {
    position: fixed;
    top: 0;
    left: 0;
    width: var(--app-width);
    height: var(--app-height);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: var(--z-index-modal-overlay);
    background-color: rgba(255, 255, 255, 0.5);
    clip-path: circle(calc(var(--size-base) * 60 * 3) at 50% 50%);

    scale: 1;

    ::v-deep>* {
      position: static !important;
    }
  }
}
</style>